import React from "react";
import { Link } from "react-router-dom";


export default function ShopPanel() {
    return (
        <div>
            <Link to='/shop'><button className='playButton' style={{width: '150px'}}>Go to the Shop</button></Link>
        </div>
    );
}
